<template>
  <component-wrapper class="cookie-declaration-fi">
    <grid-container-fi v-if="isMounted">
      <div class="fi-col-start-1 fi-col-end-13 md:fi-col-start-2 md:fi-col-end-12">
        <div
          ref="cookieDeclaration"
          class="cookie-declaration-fi__content richtext-fi"
        />
      </div>
    </grid-container-fi>

    <loading-indicator
      v-else
      variant="spinnerLocal"
    />
  </component-wrapper>
</template>

<script setup lang="ts">
import { LoadingIndicator } from 'atoms';
import { nextTick, onMounted, ref, useTemplateRef } from 'vue';

import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useFischer } from '@/composables/fischerPlugin';

defineOptions({ name: 'CookieDeclaration' });

const fischer = useFischer();

const isMounted = ref(false);
const cookieDeclaration = useTemplateRef<HTMLElement>('cookieDeclaration');

onMounted(async () => {
  isMounted.value = true;
  await nextTick();

  if (fischer.cookieBotId() && cookieDeclaration.value) {
    const cookiebotScript = document.createElement('script');
    cookiebotScript.type = 'text/javascript';
    cookiebotScript.setAttribute(
      'src',
      `https://consent.cookiebot.com/${fischer.cookieBotId()}/cd.js`,
    );
    cookiebotScript.async = true;
    cookieDeclaration.value.appendChild(cookiebotScript);
  } else if (!cookieDeclaration.value) {
    console.error('Missing cookiebot ref');
  } else {
    console.info('No CookieBot ID defined for this site');
  }
});
</script>

<style src="./cookie-declaration-fi-unscoped" />
